import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnalytics: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnalytics"><Path d="M3 11.25V3H21V11.25H16.6886L13.961 6.40091L9.96102 14.4009L8.18864 11.25H3Z" fill="currentColor"/><Path d="M3 12.75V21H21V12.75H15.8114L14.039 9.59909L10.039 17.5991L7.31136 12.75H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnalytics;
